import "./index.scss";

import React from "react";
import { connect } from "react-redux";
import { showToast } from "Source/globalFunction";

import HeaderTabs from "./HeaderTabs/HeaderTabs";
import DetailsTab from "./Tabs/DetailsTab/DetailsTab";
import LinksTab from "./Tabs/LinksTab/LinksTab";
import MembersTab from "./Tabs/MembersTab/MembersTab";
import AttachmentsTab from "./Tabs/AttachmentsTab/AttachmentsTab";
import DiscardChanges from "Components/common/DiscardChanges/DiscardChanges";
import Axios from "Source/axiosPool";
import _ from 'lodash'
import NavigationBLocker from "Components/common/NavigationBlocker/NavigationBlocker"

@connect(store => {
    return {
        conversations: store.conversations,
        loggedUser: store.loggedUser,
        project: store.project,
        settings: store.settings,
        notes: store.notes
    }
})

class ConversationInfo extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            activeMenu: { id: "details", label: "Details" },
            menus: [
                { id: "details", label: "Details" },
                { id: "links", label: "Links" },
                { id: "members", label: "Members" },
                { id: "attachments", label: "Attachments" }
            ],
            selected: {},
            workstreams: [],
            fields: {},

        }
        _.map(["fetchWorkstreams", "toField"
        ], fn => {
            this[fn] = this[fn].bind(this);
        });
    }

    componentDidMount() {
        const { conversations } = this.props
        this.fetchWorkstreams()
        this.toField(conversations.selected)
        this.setState({ selected: conversations.selected })
    }

    componentDidUpdate(prev) {
        const { conversations } = this.props
        if (!_.isEqual(prev.conversations.selected.id, conversations.selected.id) && conversations.selected.id) {
            this.fetchWorkstreams()
            this.toField(conversations.selected)
            this.setState({ selected: conversations.selected })
        }
        if (!_.isEqual(prev.conversations.selectedTab, conversations.selectedTab)) {
            this.setState({ activeMenu: conversations.selectedTab })
        }
    }


    fetchWorkstreams(options = null) {
        const { project, loggedUser } = this.props;
        let fetchUrl = `/api/workstream`;
        const params = {
            projectId: project.Selected.id,
            page: 1,
            userId: loggedUser.data.id,
            userRole: loggedUser.data.userRole,
            workstreamStatus: 'Active',
            section: 'conversation',
            ...(options ? { workstream: options } : {})
        }

        Axios.get(fetchUrl, params).then(c => {
            if (c) {
                const workstreamOptions = _(c.data.result)
                    .map(e => {
                        return { value: e.id, label: e.workstream, color: e.color, members: e.workstreamMembers };
                    }).value();

                this.setState({ ...this.state, workstreams: workstreamOptions });
            }
        });

    }
    toField(selected) {
        this.setState({
            fields: {
                subject: selected.note,
                creator: selected.creator,
                members: selected.tagged_users.map(u => u.user),
                workstreams: selected.tagged_workstreams_notes.map(w => w.workstream),
                files: selected.notesTagDoc.map(f => f.document),
                project: selected.project
            }
        })
    }

    checkChanges = () => {
        const { conversations } = this.props
        const { selected: selectedConv } = this.state
        const first = conversations.selected;
        const second = selectedConv;

        // If no active form
        if (!Object.keys(conversations.selected).length) {
            return false;
        }
        
        const ftagUser = first.tagged_users?first.tagged_users.filter(u=>!u.isRemoved).map(f=>f.user):[]
        const stagUser = second.tagged_users?second.tagged_users.map(s=>s.user):[]
     
        const fws = first.tagged_workstreams_notes?first.tagged_workstreams_notes.filter(w=>!w.isRemoved).map(f=>f.workstream.id):[]
        const sws = second.tagged_workstreams_notes?second.tagged_workstreams_notes.map(s=>s.workstream.id):[]
     
         return (first.note !== second.note
             || !_.isEqual(ftagUser, stagUser)
             || !_.isEqual(fws, sws))
    }

    render() {
        const { dispatch, conversations, loggedUser, project, settings, notes } = this.props
        const { workstreams, selected: selectedConv } = this.state
        const handleUpdateTabs = menu => {
            dispatch({ type: "SET_CONVERSATIONS_TAB_SELECTED", selected: menu })
            this.setState({ ...this.state, activeMenu: menu })
        }
        const handleChanges = (param) => {
            this.setState({ fields: { ...this.state.fields, param } })
        }
      
        const selected = conversations.selected

        const workstreamIlead = workstreams.filter(f => {
            const lead = f.members.filter(f => f.assign === "responsible" && f.id === loggedUser.data.id)
            return lead.length > 0
        })
        const isWsLead = selected.tagged_workstreams_notes ? workstreamIlead.filter(w => {
            return selected.tagged_workstreams_notes.map(t => t.linkId).indexOf(w.value) > -1
        }) : []
        const projectManager = project.Selected.leadId
        const isAdmin = loggedUser.data.userRole < 5 || projectManager === loggedUser.data.id || isWsLead.length > 0 || (conversations.selected.id && conversations.selected.creator.id === loggedUser.data.id);

        //  const isUpdated = !_.isEqual( _.omit(conversations.selected,['notesTagDoc','dateUpdated']),_.omit(original,['notesTagDoc','dateUpdated']));
        const isUpdated = this.checkChanges();
        
        const onSaveChanges = () => {
            if (conversations.selected.id) {
                dispatch({ type: "SET_SCREEN_LOADER", Loading: true });
                const members = conversations.selected.tagged_users
                    .filter(m => !m.isRemoved || m.isArchived)
                    .map(m => ({
                        value: m.fromOption ? m.value : m.user.id,
                        label: m.fromOption ? m.label : `${m.user.firstName} ${m.user.lastName}`
                    }));

                const selectedWorkstreams = conversations.selected.tagged_workstreams_notes
                    .filter(m => !m.isRemoved)
                    .map(m => ({
                        value: m.fromOption ? m.value : m.workstream.id,
                        label: m.fromOption ? m.label : m.workstream.workstream
                    }));

                const hasArchived = conversations.selected.tagged_users
                    .filter(m => m.isArchived).length > 0;

                const params = {
                    subject: conversations.selected.note,
                    users: members,
                    workstreams: selectedWorkstreams,
                    projectId: project.Selected.id,
                    user: { id: loggedUser.data.id },
                }


                Axios.put(`/api/conversation/editConversation/${conversations.selected.id}`, params)
                    .then(response => {
                        if (response) {
                            const note = response.data[0].note;
                            const isLeave = note.tagged_users.filter(t => t.user.id === loggedUser.data.id);
                            dispatch({ type: "UPDATE_CONVERSATIONS_SELECTED", selected: { ...note, isLeave: isLeave.length === 0 } });
                            dispatch({
                                type: "SET_NOTES_LIST", list: notes.List.map(n => {
                                    if (n.id === note.id) {
                                        return note;
                                    }

                                    return n;
                                })
                            });
                            this.setState({ selected: note})
                            if (hasArchived) {
                                const putParams = {
                                    isArchived: 1,
                                    conversations: [conversations.selected.id]
                                }

                                Axios.put(`/api/conversation/setArchived/${project.Selected.id}`, putParams)
                                    .then(response => {
                                        if (response) {
                                            dispatch({
                                                type: "SET_NOTES_LIST", list: notes.List.filter(n => {
                                                    return n.id !== conversations.selected.id
                                                })
                                            });
                                            dispatch({ type: "CLEAR_CONVERSATIONS_SELECTED" });

                                            dispatch({ type: "SET_CONVERSATIONS_SHOW_INFO_MODAL", showInfoModal: false });
                                            $("#view-conversation-form").modal("hide");
                                        }

                                        dispatch({ type: "SET_SCREEN_LOADER", Loading: false });
                                    });
                            } else {
                                const getParams = {
                                    linkType: "notes",
                                    linkId: conversations.selected.id,
                                    page: 1,
                                    projectId: project.Selected.id,
                                };

                                Axios.get(`api/conversation/getConversationListV2`, getParams)
                                    .then(response => {
                                        if (response) {
                                            dispatch({ type: "UPDATE_CONVERSATIONS_SELECTED_EVENTS", events: response.data.event });

                                            if (isLeave.length === 0) {
                                                dispatch({ type: "SET_CONVERSATIONS_SHOW_INFO_MODAL", showInfoModal: false });
                                            }

                                            showToast("success", "Changes successfully saved!");
                                        }

                                        dispatch({ type: "SET_SCREEN_LOADER", Loading: false });
                                    });
                            }

                        }
                    });
            }
        };

        const onCancelModal = () => {
            if (isUpdated) {
                $("#discardChanges").modal("show");
            } else {
                dispatch({ type: "SET_CONVERSATIONS_SHOW_INFO_MODAL", showInfoModal: false });
            }
            // dispatch({ type: "SET_CONVERSATIONS_TAB_SELECTED", selected: { id: "details", label: "Details" } })
        }

        const onCancelChanges = () => {
            dispatch({ type: "UPDATE_CONVERSATIONS_SELECTED", selected: selectedConv });

            showToast("success", "Changes have been discarded");
            $("#discardChanges").modal("hide");
            dispatch({ type: "SET_CONVERSATIONS_SHOW_INFO_MODAL", showInfoModal: false });
        }

        return (
            <div>
                <div class="modal fade bg-overlay conversation-info show in" id="conversation-info-modal" data-backdrop="static" data-keyboard="false">
                    <div class="modal-dialog">
                        <div class="modal-content">
                            <div class="modal-header">
                                <div class="mainHeader">
                                    <div class="header-subject">
                                        <h4>{selectedConv.note}</h4>
                                    </div>
                                    <a aria-label="Close" onClick={onCancelModal}>
                                        <i class="material-icons">close</i>
                                    </a>
                                </div>

                                <HeaderTabs menus={this.state.menus} activeMenu={this.state.activeMenu} handleUpdateTabs={handleUpdateTabs} />
                            </div>

                            <div class="modal-body">
                                {this.state.activeMenu.id === "details" && <DetailsTab isAdmin={isAdmin} />}
                                {this.state.activeMenu.id === "links" && <LinksTab isAdmin={isAdmin} />}
                                {this.state.activeMenu.id === "members" && <MembersTab isAdmin={isAdmin} />}
                                {this.state.activeMenu.id === "attachments" && <AttachmentsTab isAdmin={isAdmin} />}
                            </div>


                            <div class="modal-footer bt">
                                {isAdmin && this.state.activeMenu.id !== "attachments" && !selected.isArchived &&
                                    <div class="footerActions">
                                        <div class="actionButton">
                                            <button type="button" class="btnCancel" onClick={onCancelModal}>Cancel</button>
                                        </div>
                                        <div class="actionButton">
                                            <button type="button" class={`btnSave ${isUpdated ? "active" : ""}`} onClick={onSaveChanges}>Save Changes</button>
                                        </div>
                                    </div>
                                }
                            </div>

                        </div>
                    </div>
                </div>
                <DiscardChanges onCancel={onCancelChanges} />
                <NavigationBLocker navigationBlocked={isUpdated}/>
            </div>
        );
    }
}

export default ConversationInfo;